import { render, staticRenderFns } from "./InvoiceList-Receipt.vue?vue&type=template&id=6b42fef2&scoped=true"
import script from "./InvoiceList-Receipt.vue?vue&type=script&lang=js"
export * from "./InvoiceList-Receipt.vue?vue&type=script&lang=js"
import style1 from "./InvoiceList-Receipt.vue?vue&type=style&index=1&id=6b42fef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42fef2",
  null
  
)

export default component.exports